import { DraftInterface } from './Draft/DraftInterface'

export enum RecurringFrequencyType {
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
  MONTHLY_LAST_DAY = 'MONTHLY_LAST_DAY',
  QUARTERLY = 'QUARTERLY',
  SEMIANNUALLY = 'SEMIANNUALLY',
  YEARLY = 'YEARLY',
}
export enum RecurringDurationType {
  INDEFINITE = 'INDEFINITE',
  REPEAT = 'REPEAT',
}
export enum RecurringActionType {
  CREATE = 'create',
  CREATE_AND_SEND = 'create-and-send', // camelize this when getting translation, as the key name is createAndSend
}
/** Values for recurring profile's statuses as returned from rest-invoice */
export enum RecurringProfileStatusType {
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  COMPLETED = 'completed',
}
/** Values for recurring profile status events (= setting status). A bit complicated. */
export enum RecurringProfileStatusEventType {
  STARTED = 'started',
  PAUSED = 'paused',
  COMPLETED = 'completed',
}
export const DEFAULT_REPEAT_COUNT = 5

/** Types for eventType response from GraphQL */
export enum RecurringProfileEventType {
  PROFILE_CREATED = 'profile.created',
  PROFILE_EDITED = 'profile.edited',
  PROFILE_DELETED = 'profile.deleted',
  PROFILE_STARTED = 'profile.started',
  PROFILE_PAUSED = 'profile.paused',
  PROFILE_COMPLETED = 'profile.completed',
  PROFILE_DOCUMENT_CREATED = 'profile.document.created',
  PROFILE_SCHEDULE_ACTION_SUCCESS = 'profile.scheduler.action.succeeded',
  PROFILE_SCHEDULE_ACTION_FAIL = 'profile.scheduler.action.failed',
  PROFILE_SCHEDULE_ACTION_FAIL_SEND = 'profile.scheduler.action.failed.send',
  PROFILE_SCHEDULE_SUBSCRIPTION_FAIL = 'profile.scheduler.subscription.failed',
  PROFILE_ACCOUNTING_COMPLIANCE_FAIL = 'profile.accounting.comply.failed',
}

export enum RecurringProfileAcionErrorCode {
  CREATE = 'CREATE_ERROR',
  SEND = 'SEND_ERROR',
}

export interface RecurringMessageInterface {
  to: string
  body: string
  acceptStripePayment?: boolean
  attachmentUuids?: string[] // TODO: not yet implemented
}

export interface RecurringProfileEventInterface {
  createdAt: string
  eventType: RecurringProfileEventType
  eventData?: any
}

export interface RecurringProfileStatusInterface {
  status: RecurringProfileStatusType
  nextScheduleDate: string
  events: RecurringProfileEventInterface[]
}

export interface RecurringProfileSettingsInterface {
  frequency: RecurringFrequencyType
  startDate: string
  repeat: number | null
  action: RecurringActionType
  confirmation: boolean
  message: RecurringMessageInterface
  id?: number
  status?: RecurringProfileStatusType
}

export interface RecurringProfileInterface {
  id?: number
  draft: DraftInterface
  schedule: RecurringProfileSettingsInterface
  status?: RecurringProfileStatusInterface
}
